import { VueQueryPlugin } from '@tanstack/vue-query';
import type { App } from 'vue';

import { queryClient } from '@/shared/lib/query-client';

export const withVueQuery = (app: App) => {
  app.use(VueQueryPlugin, { queryClient });
};
